export default __webpack_public_path__ + "static/error-bd97992426575448e943848ae70fa370.png";